import type { CarrierLogoProps } from './types'
import { VESYLLogo } from '../logo'
import * as React from 'react'
import { useColorMode } from '../../components/color-mode'

export const VESYLSelectLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function VESYLSelectLogo(props, ref) {
    const { colorMode } = useColorMode()
    const { w, width, ...restProps } = props
    const iconColor = colorMode === 'dark' ? '#edfc33' : '#000000'

    // Default to w="4" (16px) to match other carrier logos
    const computedWidth = w !== undefined ? w : width !== undefined ? width : '4'

    return (
      <VESYLLogo
        ref={ref}
        iconColor={iconColor}
        variant="logomark"
        w={computedWidth}
        {...restProps}
      />
    )
  },
)
